module.exports = __webpack_public_path__ + "assets/img/16-l.a1ea460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/16-l.jpg
// module id = 7elO
// module chunks = 0